@if (heading().title) {
  @if (heading().visuallyHidden) {
    <h1 class="visually-hidden">{{ heading().title }}</h1>
  } @else {
    <header class="page-heading">
      <h1 class="page-heading-title">{{ heading().title }}</h1>
      @if (heading().lead) {
        <p class="page-heading-lead">{{ heading().lead }}</p>
      }
    </header>
  }
}
